/**
 * totals returns an object with calculated subtotal, taxes and total price in cents
 *
 * @param sku
 * @returns {{total: number, subtotal: number, taxes: number}}
 */
export const totals = (sku) => {
    let subtotal = 0;
    let taxes = 0;
    let total = 0;

    if (sku.taxInc) {
        total = sku.price/100;
        taxes = total - (total/((100+sku.taxRate)/100))
        subtotal = total - taxes;
    } else {
        subtotal = sku.price/100
        taxes = Math.round(sku.taxRate * sku.price/100)/100
        total = subtotal + taxes
    }

    return { subtotal, taxes, total }
}